import { convert, type ConvertableUnit } from "@/libs/units";
import type { NumericPoint } from "@incytestudios/ddv";
import { isFinitePoint, isNaturalPoint } from "./numericPointUtils";

export function normalizeTornadoPoints(
  points: NumericPoint[],
  baseXUnit: ConvertableUnit,
  targetXUnit: ConvertableUnit,
  baseYUnit: ConvertableUnit,
  targetYUnit: ConvertableUnit
) {
  return points
    .filter(isFinitePoint)
    .filter(isNaturalPoint)
    .map(p => {
      return {
        ...p,
        x: convert(p.x, baseXUnit, targetXUnit),
        y: convert(p.y, baseYUnit, targetYUnit)
      };
    });
}
